// Cloudflare injects this value at build time. Normalize it here so URL
// construction remains correct whether the configured value ends in "/" or not.
export const normalizeBackendUrl = (url = '') => url.replace(/\/+$/, '');

export const BACKEND_URL = normalizeBackendUrl(process.env.REACT_APP_BACKEND_URL);
